import { NavBarComponent as NavBar } from "./nav.component";
export default NavBar;
